export const POLLING_INTERVAL = 500;
// TODO: Revisit timeout functionality
export const STREAMING_CHECK_DELAY = 15000;
export const MAX_RETRIES = 3;
export const RESPONSE_TIMEOUT_MS = 90000;
export const GUARDRAIL_REJECTION_MESSAGE = "Sorry, Ask TeamForm cannot respond";

export const SOURCE_TYPES = {
  chat_q_and_a: "chat_q_and_a",
  team_summary: "team_summary",
  forecast_summary: "forecast_summary",
  personal_elevator_pitch: "personal_elevator_pitch",
};

export const AGENTCORE_NAMES = {
  ASK_TEAMFORM: "ask_teamform",
  SUMMARIES: "summaries",
};

export const DASHBOARD_REGEX =
  /\|dashboard([^|]*)\|\s*<\/p>\s*(.*?)(?:\|dashboard\||<\/final-response>|$)/gs;

export const DASHBOARD_REGEX_V2 =
  /<dashboard([^>]*)>((?!<\/dashboard>).+)(<\/dashboard>)/gs;

export const GRAPH_REGEX = /<graph([^>]*)>((?!<\/graph>).+)(<\/graph>)/gs;
